// NPM Imports
import React from "react";
// import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Components Imports

// Actions Imports

// Services Imports

// Internal Imports
import { DOCUMENTS } from "../../../constants";

// Destructuring
const { DOCUMENT_MODE, DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

export default function ComponentImgEditBtn({
  addAltText,
  clearReplaceImage,
  mode,
  sectionType,
  lock,
  clauseOptions,
  sectionData,
  totalRowItems,
}) {
  if (
    lock === true || // if image is locked
    sectionType !== DOCUMENT_COMPONENT_TYPES.IMAGE || // if this section is not an image
    !sectionData || // if there is no image data
    (mode === DOCUMENT_MODE.TEMPLATE && clauseOptions)
  ) {
    return null;
  }

  if (totalRowItems === 1) {
    return (
      <div className="component-divide">
        <div className="divide-line" />
        <Tooltip
          placement="top"
          overlay="Replace image"
          align={{ offset: [0, 3] }}>
          <span
            data-test="replace-image-button"
            className="btn-icon"
            id="edit-sec-btn"
            onMouseDown={clearReplaceImage}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}>
            <FontAwesomeIcon icon={["far", "images"]} />
          </span>
        </Tooltip>
        <Tooltip
          placement="top"
          overlay="Add alt-text"
          align={{ offset: [0, 2] }}>
          <span
            data-test="alt-text-image-button"
            className="btn-icon"
            id="edit-sec-btns"
            onMouseDown={addAltText}
            onKeyUp={() => {}}
            role="button"
            tabIndex={0}>
            <FontAwesomeIcon icon={["far", "edit"]} />
          </span>
        </Tooltip>
        <div className="divide-line" />
      </div>
    );
  }
  return null;
}
